import script from "./SubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=038b5a9c&lang=css"

const __exports__ = script;

export default __exports__